import type { ThemeBundle } from '../types';
import { editorialTheme, editorialResolver } from './theme';
import { MastheadBar } from './MastheadBar';

export const editorialBundle: ThemeBundle = {
  key: 'editorial',
  theme: editorialTheme,
  cssVariablesResolver: editorialResolver,
  Chrome: MastheadBar,
  // Vite emits these CSS files (and the woff2 assets fonts.css references)
  // into a separate chunk that is NOT in the entry import graph. Baseline
  // users never download editorial CSS or its variable fonts.
  loadStyles: () => Promise.all([
    import('./styles/tokens.css'),
    import('./styles/fonts.css'),
    import('./styles/components.css'),
    import('./styles/header.css'),
  ]),
};
